import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { Card, Loader } from '../components';
import { AuthActions } from '../actions';
import { routes } from '../constants';

class ExternalLoginPage extends React.Component {

    componentWillMount() {
        let refreshToken = this.props.location.query.refresh_token;
        if (refreshToken) {
            this.props.dispatch(AuthActions.authenticateWithRefreshToken(refreshToken));
        } else {
            browserHistory.push(routes.LOGIN);
        }
    }

    componentWillReceiveProps(props) {
        if (props.loginStatus.status === 'ERROR') {
            this.props.dispatch(AuthActions.logOut());
            browserHistory.push(routes.LOGIN);
        } else if (props.loginStatus.status === 'ACTIVE') {
            browserHistory.push(routes.HOME);
        }
    }

    render () {

        return (
            <div className="container component-login-widget" id="container-forgot-password">
                <div className="row center-cols">
                    <div className="col-md-6 col-lg-5 center">
                        <Card>
                            <div className="card-title-area">
                                <h3>Logging in...</h3>
                            </div>
                            <div className="card-body">
                                <Loader />
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {
    return {
        user: state.activeUser,
        loginStatus: state.loginStatus
    }
}

export default connect(select)(ExternalLoginPage);



// WEBPACK FOOTER //
// ./web-app/containers/external-login.jsx